import Booking from "pages/Booking";

export default function BookingPage() {
  return <Booking />;
}
